"use strict";
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridLegacy = void 0;
var React = __importStar(require("react"));
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var react_table_1 = __importStar(require("react-table"));
var gds_ux_components_1 = require("@granular/gds-ux-components");
var common_1 = require("@granular/gds-ux-components/lib/common");
require("./GKDataGridLegacy.css");
/** @deprecated in favor of GKDataGrid. Please upgrade! */
var GKDataGridLegacy = function (props) { return (React.createElement(common_1.WindowSizeManager, null,
    React.createElement(GKDataGridLegacyInternal, __assign({}, props)))); };
exports.GKDataGridLegacy = GKDataGridLegacy;
var GKDataGridLegacyInternal = function (props) {
    // Props
    var className = props.className, columns = props.columns, _a = props.data, propData = _a === void 0 ? [] : _a, qaProp = props["data-qa"], defaultExpanded = props.defaultExpanded, expandable = props.expandable, expanderHeader = props.expanderHeader, expanderTitle = props.expanderTitle, _b = props.expanderWidth, expanderWidth = _b === void 0 ? 40 : _b, headerColor = props.headerColor, id = props.id, isLoadingProp = props.isLoading, gridLines = props.gridLines, style = props.style, gridClassName = props.gridClassName, gridStyle = props.gridStyle, 
    // Intentionally destructured
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    SubComponent = props.SubComponent, selection = props.selection, onExpandedChange = props.onExpandedChange, onSelection = props.onSelection, otherProps = __rest(props, ["className", "columns", "data", "data-qa", "defaultExpanded", "expandable", "expanderHeader", "expanderTitle", "expanderWidth", "headerColor", "id", "isLoading", "gridLines", "style", "gridClassName", "gridStyle", "SubComponent", "selection", "onExpandedChange", "onSelection"]);
    // State
    var _c = React.useState([]), selectedRows = _c[0], setSelectedRows = _c[1];
    var _d = React.useState(defaultExpanded), expandedRows = _d[0], setExpandedRows = _d[1];
    var _e = React.useState(propData instanceof Promise ? [] : propData), data = _e[0], setData = _e[1];
    var _f = React.useState(propData instanceof Promise), isLoading = _f[0], setIsLoading = _f[1];
    // Expander handlers
    var handleExpandChange = function (newExpanded, event, isTouch) {
        setExpandedRows(newExpanded);
        onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange(newExpanded, event, isTouch);
    };
    var expandAll = function (event) {
        var allRowsExpanded = {};
        data.forEach(function (d, i) { return (allRowsExpanded[i] = true); });
        setExpandedRows(allRowsExpanded);
        onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange(allRowsExpanded, event, false);
    };
    var collapseAll = function (event) {
        setExpandedRows({});
        onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange({}, event, false);
    };
    var defaultGridProps = {
        className: [
            "gk-data-grid-table",
            headerColor ? "header-bg-" + headerColor : "header-bg-light",
            gridLines ? "grid-lines-" + gridLines : "grid-lines-horizontal",
            props.sortable === false ? null : "sortable",
        ]
            .filter(function (i) { return i; })
            .join(" "),
        collapseOnDataChange: true,
        showPagination: false,
        showPageSizeOptions: false,
        pageSize: data.length || 1,
        column: __assign(__assign({}, react_table_1.ReactTableDefaults.column), { Filter: function (params) {
                var Filter = (React.createElement(gds_ux_components_1.GKInput, { bsSize: "sm", onChange: function (event) {
                        return params.onChange(event.target.value);
                    }, value: params.filter ? params.filter.value : "" }));
                return Filter;
            } }),
        getTheadThProps: function (state, rowInfo, column) {
            var sortable = false;
            // If the column is sortable, or the table is sortable and the
            // column doesn't explicitly set sortable to false, sortable is true.
            if (column.sortable || (state.sortable && column.sortable !== false)) {
                sortable = true;
            }
            return {
                className: sortable ? "sortable" : undefined,
            };
        },
        getTrProps: function (state, rowInfo) {
            var isSelected = selectedRows.some(function (row) {
                return (0, react_fast_compare_1.default)(row, rowInfo.original);
            });
            return {
                className: isSelected ? "active" : undefined,
            };
        },
        ExpanderComponent: function (cell) {
            var ExpanderComponent = (React.createElement("div", { className: "gk-data-grid-expander ml-auto " + (cell.isExpanded ? "expanded" : "") },
                expanderTitle && (React.createElement("strong", null, typeof expanderTitle === "string"
                    ? expanderTitle
                    : expanderTitle(cell, cell.isExpanded))),
                React.createElement(gds_ux_components_1.GKIcon, { name: gds_ux_components_1.GKIconName.KeyboardArrowDown })));
            return ExpanderComponent;
        },
        expanded: expandedRows,
        onSortedChange: function () { return collapseAll(); },
    };
    var mergedGridProps = __assign(__assign(__assign({}, defaultGridProps), { className: "" + defaultGridProps.className + (gridClassName ? " " + gridClassName : ""), style: gridStyle, SubComponent: props.SubComponent ? props.SubComponent : false }), otherProps);
    // Effects and hooks
    var responsiveCols = (0, common_1.useResponsive2)(columns);
    React.useEffect(function () {
        setIsLoading(propData instanceof Promise);
        Promise.resolve(propData).then(function (promisedData) {
            setIsLoading(false);
            setData(promisedData);
        });
    }, [propData]);
    React.useEffect(function () { return setSelectedRows(selection || []); }, [selection, data]);
    React.useEffect(function () { return (props.collapseOnDataChange ? collapseAll() : undefined); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]);
    React.useEffect(function () { return setExpandedRows(defaultExpanded); }, [defaultExpanded]);
    // Select and Select All handlers
    var handleSelectAll = function (event) {
        var checked = event.target.checked;
        var selected = checked ? data : [];
        setSelectedRows(selected);
        onSelection === null || onSelection === void 0 ? void 0 : onSelection(selected);
    };
    var handleSelect = function (event, cell) {
        var checked = event.target.checked;
        var rowData = cell.original;
        var selected = checked
            ? __spreadArray(__spreadArray([], selectedRows, true), [rowData], false) : selectedRows.filter(function (row) { return !(0, react_fast_compare_1.default)(row, rowData); });
        setSelectedRows(selected);
        onSelection === null || onSelection === void 0 ? void 0 : onSelection(selected);
    };
    // The select column definition
    var selectColumn = {
        Header: function () {
            var someSelected = selectedRows.length > 0;
            var allSelected = data.every(function (d) { return selectedRows.includes(d); });
            var Header = (React.createElement(gds_ux_components_1.GKCheckbox, { className: "m-0", indeterminate: someSelected && !allSelected, checked: allSelected, disabled: isLoading, onChange: function (event) { return handleSelectAll(event); } }));
            return Header;
        },
        Cell: function (cell) {
            var Cell = (React.createElement(gds_ux_components_1.GKCheckbox, { className: "m-0", checked: selectedRows.some(function (d) { return (0, react_fast_compare_1.default)(d, cell.original); }), onChange: function (event) { return handleSelect(event, cell); } }));
            return Cell;
        },
        sortable: false,
        resizable: false,
        width: 45,
    };
    // The expander column definition (the cell is defined in defaultGridProps)
    var expanderColumn = {
        expander: !(isLoadingProp !== null && isLoadingProp !== void 0 ? isLoadingProp : isLoading),
        width: expanderWidth,
        Header: function (cell) {
            var allExpanded = Object.values(expandedRows || {}).filter(function (r) { return r; }).length ===
                data.length;
            var Header = (React.createElement("div", { className: "gk-data-grid-expander ml-auto " + (allExpanded ? "expanded" : ""), onClick: allExpanded ? collapseAll : expandAll },
                expanderHeader && (React.createElement("strong", null, typeof expanderHeader === "string"
                    ? expanderHeader
                    : expanderHeader(cell, allExpanded))),
                React.createElement(gds_ux_components_1.GKIcon, { name: gds_ux_components_1.GKIconName.KeyboardArrowDown })));
            return Header;
        },
    };
    // Get the columns (adds select and/or expander columns).
    var getColumns = function () {
        var preppedCols = __spreadArray([], (responsiveCols || []), true);
        if (expandable) {
            preppedCols.push(expanderColumn);
        }
        if (onSelection) {
            preppedCols.unshift(selectColumn);
        }
        return preppedCols;
    };
    // Render
    return (React.createElement("div", __assign({}, (0, common_1.useMergedProps)({ className: className, id: id, "data-qa": qaProp, style: style }, { _gkComponentIdentifier: "gk-data-grid" })),
        React.createElement(gds_ux_components_1.GKLoading, { isLoading: isLoadingProp !== null && isLoadingProp !== void 0 ? isLoadingProp : isLoading },
            React.createElement(gds_ux_components_1.GKLoadingState, null,
                React.createElement(react_table_1.default, { columns: getColumns().map(function (c) { return (__assign(__assign({}, c), { Cell: function () {
                            var Cell = React.createElement(gds_ux_components_1.GKLoadingPlaceholder, { className: "d-block w-75" });
                            return Cell;
                        } })); }), data: new Array(5).fill(0), className: defaultGridProps.className, showPagination: false, showPageSizeOptions: false, pageSize: 5, style: gridStyle })),
            React.createElement(gds_ux_components_1.GKCompletedState, null,
                React.createElement(react_table_1.default, __assign({ columns: getColumns(), data: data }, mergedGridProps, { onExpandedChange: handleExpandChange }))))));
};
exports.default = exports.GKDataGridLegacy;
